const DIAGRAM_KEYWORDS = [
    { match: /^\s*flowchart\b/i, type: 'flowchart' },
    { match: /^\s*graph\b/i, type: 'flowchart' },
    { match: /^\s*sequenceDiagram\b/i, type: 'sequence' },
    { match: /^\s*classDiagram(?:-v2)?\b/i, type: 'class' },
    { match: /^\s*stateDiagram(?:-v2)?\b/i, type: 'state' },
    { match: /^\s*erDiagram\b/i, type: 'er' },
    { match: /^\s*gantt\b/i, type: 'gantt' },
    { match: /^\s*c4Context\b/i, type: 'c4Context' },
    { match: /^\s*c4Container\b/i, type: 'c4Container' },
    { match: /^\s*c4Component\b/i, type: 'c4Component' },
    { match: /^\s*c4Dynamic\b/i, type: 'c4Dynamic' },
    { match: /^\s*c4Deployment\b/i, type: 'c4Deployment' },
    { match: /^\s*journey\b/i, type: 'journey' },
    { match: /^\s*requirementDiagram\b/i, type: 'requirement' },
    { match: /^\s*gitGraph\b/i, type: 'gitgraph' },
    { match: /^\s*mindmap\b/i, type: 'mindmap' },
    { match: /^\s*timeline\b/i, type: 'timeline' },
    { match: /^\s*block-beta\b/i, type: 'block' },
    { match: /^\s*block\b/i, type: 'block' },
    { match: /^\s*pie\b/i, type: 'pie' },
    { match: /^\s*quadrantChart\b/i, type: 'quadrant' },
    { match: /^\s*sankey-beta\b/i, type: 'sankey' },
    { match: /^\s*packet-beta\b/i, type: 'packet' },
    { match: /^\s*architecture-beta\b/i, type: 'architecture' },
    { match: /^\s*radar-beta\b/i, type: 'radar' },
    { match: /^\s*treemap-beta\b/i, type: 'block' },
];
export const detectDiagramType = (source) => {
    const trimmed = source.replace(/^```(?:mermaid)?\s*/i, '').trimStart();
    const firstLine = trimmed.split(/\r?\n/).find((l) => l.trim().length > 0) ?? '';
    for (const k of DIAGRAM_KEYWORDS) {
        if (k.match.test(firstLine))
            return k.type;
    }
    // fallback heuristic: assume flowchart
    return 'flowchart';
};
export const stripFences = (source) => source
    .replace(/^```(?:mermaid)?\s*\n/i, '')
    .replace(/\n```\s*$/i, '')
    .replace(/%%\{[^}]*\}%%/g, '');
export const splitLines = (source) => stripFences(source)
    .split(/\r?\n/)
    .map((l) => l.replace(/\s+$/, ''))
    .filter((l) => !/^\s*%%/.test(l));
export const unquote = (value) => value.replace(/^["'`#]+|["'`]+$/g, '').trim();
export const slug = (id) => id.replace(/[^a-zA-Z0-9_]/g, '_');
/** Apply %% style override pairs (fill, stroke, stroke-width, color) into a style object. */
export const applyStyleAssignments = (styles) => styles;
//# sourceMappingURL=detect.js.map